import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'
import PrimeVue, { defaultOptions } from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip';
import vFocus from './directives/vFocus'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)

const MyPreset = definePreset(Aura, {
  semantic: {
        primary: {
    50: '{sky.50}',
100: '{sky.100}',
200: '{sky.200}',
300: '{sky.300}',
400: '{sky.400}',
500: '{sky.500}',
600: '{sky.600}',
700: '{sky.700}',
800: '{sky.800}',
900: '{sky.900}',
950: '{sky.950}'

}
    }
})

// Sentry hibajelentés beállítása
Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_MODE,
    release: import.meta.env.VITE_APP_VERSION,
    tracesSampleRate: 0,
})


app.use(PrimeVue, {
  //unstyled: true,
  theme: {
    //preset: Aura,
    preset: MyPreset,
    options: {
      prefix: 'p',
      darkModeSelector: 'system',
      cssLayer: false,
    },
  },
  locale: {
      ...defaultOptions.locale,
      firstDayOfWeek: 1,
      dayNames: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
      dayNamesShort: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
      dayNamesMin: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
      monthNames: [
        "január", "február", "március", "április", "május", "június",
        "július", "augusztus", "szeptember", "október", "november", "december"
      ],
      monthNamesShort: [
        "jan", "feb", "már", "ápr", "máj", "jún",
        "júl", "aug", "szep", "okt", "nov", "dec"
      ],
      today: "Ma",
      weekHeader: "Hét",
      dateFormat: "yy.mm.dd",
      emptySearchMessage: "Nem található egy választható elem sem.",
      emptyMessage: "Egy választható elem sem található",
      clear: "Törlés",
      passwordPrompt: "Jelszó erőssége...",
      weak: "Gyenge",
      medium: "Közepes",
      strong: "Erős"
    }
})
app.directive('tooltip', Tooltip);
app.directive('focus', vFocus);
app.use(ToastService)
app.use(router)

app.mount('#app')

// Ki-, bejelentkezés esemény esetén újratöltés
window.addEventListener('storage', (event) => {
  if (event.key === 'auth_event') {
      window.location.reload()
  }
})
